import React, { useEffect, useState } from 'react'
import "./mailbox_styles/mailcard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faStar
} from "@fortawesome/free-solid-svg-icons";
import userLogo from "../../images/user.jpg";
import { fetchUserProfileData } from '../../App';
import LoadingPage from '../LoadingPage';

const MailCard = ({ props, currentMailOption, filterField }) => {
    const [fetchedUsersDataState, setFetchedUsersDataState] = useState({});

    useEffect(() => {
        const fetchUserData = async () => {
            const fetchedUsersData = await fetchUserProfileData(props.data[filterField]);
            setFetchedUsersDataState(fetchedUsersData);
        };

        if (props.data && props.data[filterField]) {
            fetchUserData();
        }
        // eslint-disable-next-line
    }, [filterField]);


    return (
        <>
            {
                fetchedUsersDataState.profileImage_path ?
                    <div className={`mail_card ${currentMailOption === 'inbox' && props.data.opened ? "opened" : currentMailOption !== 'inbox' ? "opened" : ""}`}>
                        <div className="mail_profile">
                            <img src={fetchedUsersDataState.profileImage_path ? fetchedUsersDataState.profileImage_path : userLogo} alt="profile_image" height="40px" width="40px" className="profileLogo" />
                        </div>
                        <div className='message_container'>
                            <p className='mail_name'>{fetchedUsersDataState.displayName}</p>
                            <span className='mail_message'>{props.data.subject.length > 25 ? props.data.subject.slice(0, 25)`...` : props.data.subject}</span>
                        </div>
                        <div className='mail_time_container'>
                            <p className='mail_time'>{new Date(props.data.timestamp?.seconds * 1000).toLocaleTimeString([], { hour: 'numeric', minute: 'numeric' })}</p>
                            <button className='starred_btn'>
                                <FontAwesomeIcon icon={faStar} className={`mailStarIcon ${props.data.starred ? "starred" : ""}`} />
                            </button>
                        </div>
                    </div>
                    :
                    <LoadingPage />
            }
        </>
    )
}

export default MailCard;